import route from './route';

export default route;


// WEBPACK FOOTER //
// ./src/router/index.js